module.exports = __webpack_public_path__ + "static/media/gm_loading.c2ec4bf6.gif";